export interface TrustStat {
  value: string;
  label: string;
  icon: string;
  note?: string;
}

interface Props {
  stats: TrustStat[];
}

const TrustBar = ({ stats }: Props) => (
  <section className="relative bg-white overflow-hidden border-b border-surface-border">
    {/* Gold top accent line */}
    <div className="absolute top-0 left-0 right-0 h-[2px]" style={{ background: 'linear-gradient(90deg, transparent 0%, #C9A84C 30%, #C9A84C 70%, transparent 100%)' }} />

    <div className="max-w-[1280px] mx-auto px-8">
      <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-surface-border">
        {stats.map((stat, idx) => (
          <div
            key={idx}
            className="flex flex-col items-center justify-center text-center py-14 px-6 relative group cursor-default"
          >
            {/* Hover teal soft wash */}
            <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none rounded-none"
              style={{ background: 'radial-gradient(ellipse 80% 80% at 50% 50%, rgba(26,74,82,0.04) 0%, transparent 70%)' }} />

            {/* Icon */}
            <div className="w-11 h-11 flex items-center justify-center rounded-full mb-5 transition-all duration-300 group-hover:scale-110 flex-shrink-0"
              style={{ background: 'rgba(26,74,82,0.07)', border: '1px solid rgba(26,74,82,0.12)' }}>
              <i className={`${stat.icon} text-teal text-sm`} />
            </div>

            {/* Large numeric value */}
            <div
              className="font-serif text-charcoal font-bold leading-none mb-3 group-hover:text-teal transition-colors duration-300"
              style={{ fontSize: 'clamp(2.4rem, 3.8vw, 3.4rem)' }}
            >
              {stat.value}
            </div>

            {/* Label */}
            <div className="text-charcoal/55 text-[13px] font-sans font-medium leading-snug mb-2 tracking-wide">
              {stat.label}
            </div>

            {/* Note pill */}
            {stat.note && (
              <div className="flex items-center gap-1.5 mt-1">
                <div className="h-px w-4 bg-gold/50" />
                <span className="text-gold text-[10.5px] tracking-[0.14em] font-sans uppercase font-semibold group-hover:text-gold-mid transition-colors">
                  {stat.note}
                </span>
                <div className="h-px w-4 bg-gold/50" />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TrustBar;
